import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { CANCEL } from 'redux-saga'

import TextField from 'components/_form/TextField'
import { gtmEvent } from 'utils/client/analitics'

import Suggestions from './components/Suggestions'
import { Wrapper } from './styles'

const TextFieldWithSuggestions = ({
  onSelect,
  onChange,
  fetchApi,
  error,
  ...props
}) => {
  const wrapperRef = React.useRef(null)
  const [suggestions, setSuggestions] = React.useState([])
  const prevRequest = React.useRef()
  const [searchWord, setSearchWord] = React.useState(null)
  const [isSuggestionActive, setSuggestionActive] = React.useState(false)
  const count = 10

  const suggestionActiveCheck = React.useCallback(value => {
    setSuggestionActive(!!value.trim?.().length)
  }, [])

  const debouncedCallback = React.useCallback(
    debounce(value => {
      if (prevRequest.current) {
        prevRequest.current[CANCEL]()
      }

      prevRequest.current = fetchApi({ query: value, count })
      prevRequest.current.then(({ suggestions }) => {
        setSuggestions(suggestions)
        if (!suggestions?.length && value)
          gtmEvent({ event: 'Address is not found', description: value })
        prevRequest.current = null
      })
    }, 300),
    [prevRequest],
  )

  const onChangeHandler = React.useCallback(
    value => {
      onChange(value)
      suggestionActiveCheck(value)
      setSearchWord(value)
      debouncedCallback(value)
    },
    [debouncedCallback, onChange, suggestionActiveCheck],
  )

  const onFocusHandler = React.useCallback(e => {
    const { value } = e?.target
    if (value) {
      setSuggestionActive(true)
    }
  }, [])

  const onBlurHandler = React.useCallback(() => setSuggestionActive(false), [
    setSuggestionActive,
  ])

  const autoCompleteSelectHandler = value => {
    onSelect(value)
    setSearchWord(value?.value)
    setSuggestionActive(false)
  }

  return (
    <Wrapper ref={wrapperRef} onBlur={onBlurHandler} onFocus={onFocusHandler}>
      <TextField
        //Off autocomplete in google chrome
        autoComplete="new-password"
        style={{ paddingRight: 40 }}
        onChange={e => onChangeHandler(e.target.value)}
        {...props}
      />
      <Suggestions
        error={error}
        searchWord={searchWord}
        onSelect={autoCompleteSelectHandler}
        active={isSuggestionActive}
        setActive={setSuggestionActive}
        suggestions={suggestions}
        wrapperRef={isSuggestionActive ? wrapperRef : null}
      />
    </Wrapper>
  )
}

TextFieldWithSuggestions.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fetchApi: PropTypes.func.isRequired,
  error: PropTypes.object,
}

export default TextFieldWithSuggestions
